<ion-list lines="none">
  <ion-item
    [lines]="showLine"
    (mouseenter)="showGarbageIcon = true"
    (mouseleave)="showGarbageIcon = false"
  >
    <ion-icon
      *ngIf="icon"
      [ngStyle]="{ opacity: fullWidth ? 1 : 0 }"
      slot="start"
      [name]="icon || 'remove-outline'"
    />
    <ion-icon
      *ngIf="!icon && altIcon"
      class="alt-icon"
      slot="start"
      [src]="altIcon"
    />
    <ion-input
      class="sol-input"
      [attr.aria-label]="label"
      [fill]="fill"
      [label]="editMode ? label : ''"
      [labelPlacement]="'stacked'"
      [maskito]="maskOptions"
      [type]="inputType"
      [inputmode]="inputType"
      autocomplete="off"
      [counter]="showCharCounter"
      [maxlength]="maxChars"
      [disabled]="!editMode"
      (input)="onInputChange($event)"
      [value]="value"
      helperText="{{
        editMode ? (helperText ? (helperText | translate) : '') : ''
      }}"
      [errorText]="errorText"
      [placeholder]="placeHolder"
    >
      @if (prefix) {
        <ion-label slot="start" style="margin-top: 1px">AW-</ion-label>
      }
      @if (inputType === INPUT_TYPE.PASS) {
        <ion-icon
          [name]="
            ionInput?.type === INPUT_TYPE.PASS
              ? 'eye-outline'
              : 'eye-off-outline'
          "
          slot="end"
          style="font-size: 24px"
          (click)="togglePasswordType()"
        />
      }
      @if (secondaryIcon && inputType !== INPUT_TYPE.PASS) {
        <ion-icon
          [name]="secondaryIcon"
          size="medium"
          slot="end"
          (click)="emitSecondaryIconClick($event)"
        />
      }
      @if (showGarbageIcon && showTrashIconOnHover) {
        <ion-icon
          [@shakeTrashCan]="garbageIconState"
          name="trash"
          color="danger"
          size="large"
          slot="end"
          style="cursor: pointer"
          [attr.aria-label]="'ARIA.delete' | translate"
          [class.hidden]="!showTrashIconOnHover"
          (click)="deleteClick($event)"
        />
      }
    </ion-input>
  </ion-item>
  @if (componentType) {
    <ng-template solDynamicHost></ng-template>
  }
</ion-list>
